'use strict'

import { filter as _filter, map as _map, reject as _reject } from 'lodash'

let inj

export class CustomerFactory {
  constructor(data, $q) {
    Object.assign(this, inj, data, $q, {
      tasksites: [],
    })
  }

  getTasksiteCategories(tasksiteId) {
    return this.getTasksiteContracts(tasksiteId).then((contracts) => {
      return this.getAllCategories().then((categories) =>
        _filter(categories, (category) => _map(contracts, 'category.code').includes(category.name)),
      )
    })
  }

  getTasksites(cache = true) {
    return this.$q((resolve, reject) => {
      if (cache && this.tasksites.length) return resolve(this.tasksites)
      else {
        this.$http({
          method: 'GET',
          url: '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/tasksites',
        })
          .then((result) => {
            this.tasksites = result.data
            resolve(result.data)
          })
          .catch((err) => reject(err))
      }
    })
  }

  addTasksite(tasksite) {
    this.tasksites.push(tasksite)
  }

  removeTasksite(code) {
    this.tasksites = _reject(this.tasksites, { code })
  }

  getContractDates(tasksiteId, contractId) {
    return this.$http({
      method: 'GET',
      url:
        '/api/companies/' +
        this.companyId +
        '/customers/' +
        this.customerId +
        '/tasksites/' +
        tasksiteId +
        '/contracts/' +
        contractId +
        '/dates',
    }).then((result) => result.data)
  }

  getDocuments(from, to) {
    return this.$http({
      method: 'GET',
      url: '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/documents',
      params: { from, to },
      cache: true,
    }).then((result) => result.data)
  }

  getDocumentPdf(ref, fileName) {
    return this.DownloadService.getDocumentPdf(this.companyId, ref, fileName)
  }

  getDocumentZip(ref, fileName) {
    return this.DownloadService.getDocumentZip(this.companyId, ref, fileName)
  }

  getReport(reportId, fileName) {
    return this.DownloadService.getReport(this.companyId, this.customerId, reportId, fileName)
  }

  getUsers() {
    return this.$http({
      method: 'GET',
      url: '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/users',
    }).then((result) => {
      return result.data.map((user) => {
        return new this.UserFactory(user)
      })
    })
  }

  getTasksiteContracts(tasksiteId) {
    return this.$http({
      method: 'GET',
      url:
        '/api/companies/' +
        this.companyId +
        '/customers/' +
        this.customerId +
        '/tasksites/' +
        tasksiteId +
        '/contracts',
    }).then((result) => result.data)
  }

  getTasksiteOrders(tasksiteId, params) {
    return this.$http({
      method: 'GET',
      url:
        '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/tasksites/' + tasksiteId + '/orders',
      params,
    }).then((result) => result.data)
  }

  getTasksiteInventories(tasksiteId) {
    return this.$http({
      method: 'GET',
      url:
        '/api/companies/' +
        this.companyId +
        '/customers/' +
        this.customerId +
        '/tasksites/' +
        tasksiteId +
        '/inventories',
    }).then((result) => result.data)
  }

  cancelOrder(order) {
    console.log('cancelOrder()', order)
    if (order.source === 'ORDER') return this.deleteOrder(order.taskSiteCode, order.no)
    else if (order.source === 'CONTRACT') return this.deleteContract(order.taskSiteCode, order.no)
    else if (order.source === 'TASKSITE') return this.deleteTasksite(order.taskSiteCode)
  }

  deleteOrder(tasksiteId, orderId) {
    console.log('deleteOrder()')
    return this.$http({
      method: 'DELETE',
      url:
        '/api/companies/' +
        this.companyId +
        '/customers/' +
        this.customerId +
        '/tasksites/' +
        tasksiteId +
        '/orders/' +
        orderId,
    }).then(() => {
      return { deleted: 'ORDER', orderId }
    })
  }

  deleteContract(tasksiteId, contractId) {
    console.log('deleteContract()')
    return this.$http({
      method: 'DELETE',
      url:
        '/api/companies/' +
        this.companyId +
        '/customers/' +
        this.customerId +
        '/tasksites/' +
        tasksiteId +
        '/contracts/' +
        contractId,
    }).then(() => {
      return { deleted: 'CONTRACT', contractId }
    })
  }

  deleteTasksite(tasksiteId) {
    console.log('deleteTasksite()')
    return this.$http({
      method: 'DELETE',
      url: '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/tasksites/' + tasksiteId,
    }).then(() => {
      return { deleted: 'TASKSITE', tasksiteId }
    })
  }

  getTasksiteOrder(tasksiteId, orderId) {
    return this.$http({
      method: 'GET',
      url:
        '/api/companies/' +
        this.companyId +
        '/customers/' +
        this.customerId +
        '/tasksites/' +
        tasksiteId +
        '/orders/' +
        orderId,
    }).then((result) => result.data)
  }

  getDates(tasksiteId, contractId, lineNo) {
    return this.$http({
      method: 'GET',
      url:
        '/api/companies/' +
        this.companyId +
        '/customers/' +
        this.customerId +
        '/tasksites/' +
        tasksiteId +
        '/contracts/' +
        contractId +
        '/dates',
      params: { lineNo },
    }).then((result) => result.data)
  }

  getTasksitePermissions(tasksiteId, params) {
    return this.$http({
      method: 'GET',
      url:
        '/api/companies/' +
        this.companyId +
        '/customers/' +
        this.customerId +
        '/tasksites/' +
        tasksiteId +
        '/permissions',
      params,
    }).then((result) => result.data)
  }

  getTasksiteUsers(tasksiteId) {
    return this.$http({
      method: 'GET',
      url: '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/tasksites/' + tasksiteId + '/users',
    }).then((result) => {
      return result.data.map((user) => {
        return new this.UserFactory(user)
      })
    })
  }

  createOrder(tasksiteId, data) {
    return this.$http({
      method: 'POST',
      url:
        '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/tasksites/' + tasksiteId + '/orders',
      data,
    })
  }

  createContract(tasksiteId, data) {
    return this.$http({
      method: 'POST',
      url:
        '/api/companies/' +
        this.companyId +
        '/customers/' +
        this.customerId +
        '/tasksites/' +
        tasksiteId +
        '/contracts',
      data,
    }).then((result) => result.data)
  }

  createTasksite(data) {
    return this.$http({
      method: 'POST',
      url: '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/tasksites',
      data,
    }).then((result) => result.data)
  }

  createInvitation(tasksiteId, data) {
    return this.$http({
      method: 'POST',
      url:
        '/api/companies/' +
        this.companyId +
        '/customers/' +
        this.customerId +
        '/tasksites/' +
        tasksiteId +
        '/invitations',
      data,
    }).then((result) => result.data)
  }

  createAdmin(data) {
    return this.$http({
      method: 'POST',
      url: '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/admins',
      data,
    })
  }

  patchAdmin(data) {
    return this.$http({
      method: 'PATCH',
      url: '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/admins',
      data,
    })
  }

  createPermissions(data) {
    return this.$http({
      method: 'POST',
      url: '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/permissions',
      data,
    })
  }

  patchPermissions(data) {
    return this.$http({
      method: 'PATCH',
      url: '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/permissions',
      data,
    })
  }

  getReports() {
    return this.$http({
      method: 'GET',
      url: '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/reports',
    }).then((result) => result.data)
  }

  getReportTypes() {
    return this.$http({
      method: 'GET',
      url: '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/report-types',
    }).then((result) => result.data)
  }

  createReport(data) {
    return this.$http({
      method: 'POST',
      url: '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/reports',
      data,
    }).then((result) => result.data)
  }

  deleteReport(id) {
    return this.$http({
      method: 'DELETE',
      url: '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/reports/' + id,
    }).then((result) => result.data)
  }

  sendSupport(data) {
    return this.$http({
      method: 'POST',
      url: '/api/companies/' + this.companyId + '/customers/' + this.customerId + '/supports',
      data,
    }).then((result) => result.data)
  }

  static factory($q, $http, UserFactory, DownloadService) {
    'ngInject'
    inj = { $q, $http, UserFactory, DownloadService }
    return CustomerFactory
  }
}



// WEBPACK FOOTER //
// ./app/shared/services/customer.factory.js